import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as outcomes from '../../../../outcomes'
import * as metric from '../metric'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: metric.RESOURCE.payload.dimension.partialId,
      partialId: metric.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Outcome that the metric is measuring',
    isOptional: false,
    name: 'Outcome',
    partialId: PartialId.Standard.create('outcome'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(outcomes.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
